import IsAuthenticatedWrapper from './isAuthenticatedWrapper';

export default IsAuthenticatedWrapper;